export const getNewEmployeesLast30Days = (
  employeeData = []
) => {
  const currentDate = new Date();

  const last30DaysDate = new Date();
  last30DaysDate.setDate(
    currentDate.getDate() - 30
  );

  const employees = employeeData.filter(
    (employee) => {
      const joiningDate = new Date(
        employee.joining_date
      );

      return (
        joiningDate >= last30DaysDate &&
        joiningDate <= currentDate
      );
    }
  );

  return {
    employees,
    count: employees.length,
  };
};

export const getEmployeeExitLast30Days = (
  employeeExitData = []
) => {
  const currentDate = new Date();

  const last30DaysDate = new Date();

  last30DaysDate.setDate(
    currentDate.getDate() - 30
  );

  const employees = employeeExitData.filter(
    (employee) => {
      const lastWorkingDate = new Date(
        employee.last_working_date
      );

      return (
        lastWorkingDate >= last30DaysDate &&
        lastWorkingDate <= currentDate
      );
    }
  );

  return {
    employees,
    count: employees.length,
  };
};